module.exports = __webpack_public_path__ + "static/media/bedroom3.7feb2aba.jpg";